module.exports = __webpack_public_path__ + "img/code.1a46fe47.png";